"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var FeSelfContainedInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FeSelfContainedInput, _Component);

  function FeSelfContainedInput() {
    _classCallCheck(this, FeSelfContainedInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(FeSelfContainedInput).apply(this, arguments));
  }

  _createClass(FeSelfContainedInput, [{
    key: "render",
    value: function render() {
      var _this = this;
      /** Minimum condition required to render*/

      /** Rendering of component */


      var WrapperClassName = (0, _classnames.default)({
        'fe-form__input-wrapper--has-icon': this.props.optionalComponent
      }, this.props.className);
      var className = (0, _classnames.default)('fe-input', {
        'fe-input--light-bg': this.props.feBackground === 'light'
      }, 'fe-input--self-contained');
      var inputProps = Object.assign({}, this.props);
      delete inputProps.isInline;
      delete inputProps.feBackground;
      delete inputProps.optionalComponent;
      return _react.default.createElement("div", {
        className: WrapperClassName
      }, _react.default.createElement("input", _extends({
        type: "text"
      }, inputProps, {
        className: className,
        ref: function ref(node) {
          return _this.input = node;
        }
      })), this.props.optionalComponent ? _react.default.createElement("div", {
        className: "fe-input-icon"
      }, this.props.optionalComponent) : null);
    }
  }]);

  return FeSelfContainedInput;
}(_react.Component);

FeSelfContainedInput.defaultProps = {
  feBackground: 'default',
  placeholder: '',
  optionalComponent: null,
  disabled: false
};
FeSelfContainedInput.propTypes = {
  /** Provide background for input */
  feBackground: _propTypes.default.oneOf(['default', 'light']),

  /** Provide placeholder for input */
  placeholder: _propTypes.default.string,

  /** Provide optional custom componentr*/
  optionalComponent: _propTypes.default.element,

  /** Set true/false to change button disabled state*/
  disabled: _propTypes.default.bool
};
FeSelfContainedInput.displayName = 'FeSelfContainedInput';
var _default = FeSelfContainedInput;
exports.default = _default;